export default "__VITE_ASSET__Bgrze6I5__"